import React, { memo } from 'react'
import { number, string } from 'prop-types'

export const BMonogram = memo(({ fill = '#FFFFFF', height = 536.5, width = 600 }) => {
	return (
		<svg
			version="1.1"
			width={width}
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 84.5 83.7"
			style={{ enableBackground: 'new 0 0 84.5 83.7' }}
			xmlSpace="preserve"
		>
			<g id="Layer_3" style={{ display: 'none' }}></g>
			<g id="Layer_1">
				<g>
					<path
						fill={fill}
						d="M23.4,0v22.5c0,2.3,0,4.2-1.1,14.3h0.2c3.3-7.7,9.5-11.8,18.9-11.8c12.9,0,21.5,9.7,21.5,25.5
                c0,19.1-10.4,32.8-31.1,32.8c-8.2,0-18.6-2-23.3-4.7V10.9H0V0H23.4z M23.1,69c2.1,1.2,6.2,2,9.5,2c9.8,0,15.4-7.9,15.4-19
                c0-9.5-4.2-15-12.1-15c-8.2,0-12.8,5.5-12.8,13.7V69z"
					/>
					<circle fill={fill} cx="74.9" cy="74.1" r="9.6" />
				</g>
			</g>
			<g id="Layer_2"></g>
		</svg>
	)
})

BMonogram.propTypes = {
	fill: string,
	height: number,
	width: number,
}
